const routes = [
  {
    path: 'menu',
    redirect: { name: 'MenuList' },
    children: [
      // 홈페이지관리 > 메뉴/콘텐츠관리
      {
        path: 'list',
        name: 'MenuList',
        meta: { menu: 'menu' },
        component: () => import('@/pages/cmsMng/homepageMng/menu/MenuListView.vue')
      },
    ]
  },
  {
    path: 'contents',
    redirect: { name: 'ContentsList' },
    children: [
      // 홈페이지관리 > 메뉴/콘텐츠관리
      {
        path: 'list',
        name: 'ContentsList',
        meta: { menu: 'contents', keepAlive: true },
        component: () => import('@/pages/cmsMng/homepageMng/contents/ContentsListView.vue')
      },
      {
        path: 'add',
        name: 'ContentsInsert',
        meta: { menu: 'contents', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/contents/ContentsInsertView.vue')
      },
      {
        path: 'modify/:contsId',
        name: 'ContentsUpdate',
        meta: { menu: 'contents', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/contents/ContentsUpdateView.vue'),
        props: true
      },
      {
        path: 'view/:contsId',
        name: 'ContentsView',
        meta: { menu: 'contents', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/contents/ContentsDetailView.vue'),
        props: (route) => ({
          contsId: route.params.contsId || ''
        }),
      },
    ]
  },
  {
    path: 'domain',
    redirect: { name: 'DomainList' },
    children: [
      // 홈페이지관리 > 도메인관리
      {
        path: 'list',
        name: 'DomainList',
        meta: { menu: 'domain', keepAlive: true },
        component: () => import('@/pages/cmsMng/homepageMng/domain/DomainListView.vue')
      },
      {
        path: 'add',
        name: 'DomainInsert',
        meta: { menu: 'domain', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/domain/DomainInsertView.vue')
      },
      {
        path: 'modify/:dmnId',
        name: 'DomainUpdate',
        meta: { menu: 'domain', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/domain/DomainUpdateView.vue'),
        props: true
      },
    ]
  },
  {
    path: 'banner-group',
    redirect: { name: 'BannerGroupList' },
    children: [
      // 홈페이지관리 > 스팟, 알림, 배너관리 > 배너그룹관리
      {
        path: 'list',
        name: 'BannerGroupList',
        meta: { menu: 'banner-group', keepAlive: true },
        component: () => import('@/pages/cmsMng/homepageMng/banner/BannerGroupListView.vue')
      },
      {
        path: 'add',
        name: 'BannerGroupInsert',
        meta: { menu: 'banner-group', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/banner/BannerGroupInsertView.vue')
      },
      {
        path: 'modify/:bnrGroupId',
        name: 'BannerGroupUpdate',
        meta: { menu: 'banner-group', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/banner/BannerGroupUpdateView.vue'),
        props: true
      },
      // 홈페이지관리 > 스팟,알림,배너관리 > 배너관리
      {
        path: 'banner/:bnrGroupId',
        name: 'BannerList',
        meta: { menu: 'banner', keepAlive: true },
        component: () => import('@/pages/cmsMng/homepageMng/banner/BannerListView.vue'),
        props: true
      },
      {
        path: 'banner/add/:bnrGroupId',
        name: 'BannerInsert',
        meta: { menu: 'banner', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/banner/BannerInsertView.vue'),
        props: true
      },
      {
        path: 'banner/modify/:bnrGroupId/:bnrId',
        name: 'BannerUpdate',
        meta: { menu: 'banner', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/banner/BannerUpdateView.vue'),
        props: true
      }
    ]
  },
  {
    path: 'popup',
    redirect: { name: 'PopupList' },
    children: [
      // Popup 목록
      {
        path: 'list',
        name: 'PopupList',
        meta: { menu: 'popup', keepAlive: true },
        component: () => import('@/pages/cmsMng/homepageMng/popup/PopupListView.vue')
      },
      // Popup 등록
      {
        path: 'add',
        name: 'PopupInsert',
        meta: { menu: 'popup', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/popup/PopupInsertView.vue')
      },
      // Popup 수정
      {
        path: 'modify/:popupId',
        name: 'PopupUpdate',
        meta: { menu: 'popup', keepAlive: false },
        component: () => import('@/pages/cmsMng/homepageMng/popup/PopupUpdateView.vue'),
        props: true
      }
    ]
  },
]

export default routes


